// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"ConfirmCancelDialog_modal_header__3y0mE"};